import get from 'lodash/get';
import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  query: null,
  contracts: null,
  contract: null,
  contractTypes: [],
  offPlanProjects: [],
  musatahaLandUse: [],
  units: [],
  propertyDetails: null,
};

export default function contractReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.FETCH_CONTRACTS:
      return {
        ...state,
        loading: true,
        error: null,
        contracts: null,
      };
    case types.FETCH_PMA_PROPERTIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CONTRACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        contracts: {
          ...get(action.payload, 'contracts.result', {}),
        },
      };
    case types.FETCH_CONTRACTS_ERROR:
      return {
        ...state,
        loading: false,
        contracts: null,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_CONTRACT_DETAIL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.UPDATE_PERMISSION_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case types.FETCH_CONTRACT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        contract: {
          ...get(action.payload, 'contract', {}),
        },
      };

    case types.UPDATE_PERMISSION_ERROR: {
      return {
        loading: false,
        error: action.payload,
      };
    }
    case types.FETCH_CONTRACT_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        contract: null,
        error: get(action.payload, 'error'),
      };

    case types.CONTRACT_OPERATION_START:
      return {
        ...state,
        loading: true,
        error: null,
        contract: null,
        contracts: null,
      };
    case types.CONTRACT_OPERATION_END:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.FETCH_CONTRACTS_V2:
      return {
        ...state,
        loading: false,
        contracts: get(action.payload, 'contracts', null),
        query: get(action.payload, 'query', null),
      };
    case types.FETCH_CONTRACT_TYPES:
      return {
        ...state,
        contractTypes: get(action.payload, 'contractTypes', []),
        error: null,
      };
    case types.FETCH_PMA_CONTRACT_UNITS:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_PMA_CONTRACT_UNITS_SUCCESS:
      return {
        ...state,
        loading: false,
        units: get(action.payload?.units),
        error: null,
      };
    case types.FETCH_PMA_CONTRACT_UNITS_ERROR:
      return {
        ...state,
        loading: false,
        units: null,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_OFF_PLAN_PROJECTS:
      return {
        ...state,
        loading: true,
        error: null,
        offPlanProjects: [],
      };
    case types.FETCH_OFF_PLAN_PROJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanProjects: get(action.payload, 'projects', []),
      };
    case types.FETCH_OFF_PLAN_PROJECTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_LAND_USE_MUSTAHA:
      return {
        ...state,
        loading: true,
        error: null,
        musatahaLandUse: [],
      };
    case types.FETCH_LAND_USE_MUSTAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        musatahaLandUse: get(action.payload, 'landUse', []),
      };
    case types.FETCH_LAND_USE_MUSTAHA_FAILURE:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.DOWNLOAD_OFF_PLAN_CONTRACT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_OFF_PLAN_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_OFF_PLAN_CONTRACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_LOADING:
    case types.DOWNLOAD_LEASE_PMA_CONTRACT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_LEASE_PMA_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_LEASE_PMA_CONTRACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_CONTRACT_DETAIL_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_FAILURE:
    case types.DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyDetails: action.payload,
      };
    case types.DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
